import { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import { axiosInstance } from '../../Helpers/axiosInstance'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function CheckModal({closeModal, currentUnit, baseList, fetchInfo, item }) {
    const [base, setBase] = useState("")
    const [date, setDate] = useState(getDate(new Date()))
    const [time, setTime] = useState(null)
    const [checker, setChecker] = useState("")
    const [acquaintance, setAcquaintance] = useState("")

    const nodeRef = useRef(null);


    useEffect(() => {
        if (item) {
            setBase(item.base);
            setDate(getDate(new Date(item.date)));
            setTime(new Date(item.date).getHours().toString().padStart(2, '0') + ":" + new Date(item.date).getMinutes().toString().padStart(2, '0'));
            setChecker(item.checker);
            setAcquaintance(item.acquaintance);
        }
    }, [item]);

    function getDate(date) {
        const parts = new Intl.DateTimeFormat("en-GB").formatToParts(date);
        const day = parts.find((p) => p.type === "day").value;
        const month = parts.find((p) => p.type === "month").value;
        const year = parts.find((p) => p.type === "year").value;
        const formatted = `${day}/${month}/${year}`;
        return formatted;
    }

    function unGetDate(date) {
        if (date) {
        const [day, month, year] = date.split("/");
        const formatted = `${month}/${day}/${year}`;
        return formatted;
        }
    }


    async function add(){
            if(!base){
                toast.error("Հենակետը պարտադիր է");
                return;
            }
            const res = await axiosInstance.post("/admin/base-check", {
                mil_unit: currentUnit._id,
                base,
                date: new Date(unGetDate(date) + " " + time),
                checker,
                acquaintance
            })
            if(res.data?.status){
                closeModal()
            }
        }


    
        async function edit(){
            if(!base){
                toast.error("Հենակետը պարտադիր է");
                return;
            }
            const res = await axiosInstance.put("/admin/base-check/" + item._id, {
                mil_unit: currentUnit._id,
                base,
                date: new Date(unGetDate(date) + " " + time),
                checker,
                acquaintance
            })
            if(res.data?.status){
                closeModal()
                fetchInfo()
            }
        }
        

 return (
        <div className='fixed w-screen h-screen bg-black/40 top-0 left-0 flex justify-center items-center z-10'>
            <div ref={nodeRef} className='max-w-[90%] max-h-[90%] bg-white rounded-lg p-4 overflow-x-auto' onClick={e => e.stopPropagation()}>
                <h2 className='text-center mb-4'>Մուտքագրել ստուգման մասին տեղեկատվությունը</h2>
                <div className='grid grid-cols-2 gap-4'>
                    <div className="relative">
                        <label htmlFor="base" className='absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap'>Հենակետ</label>
                        <select id="base" className="w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200" value={base} onChange={(e) => setBase(e.target.value)}>
                            <option></option>
                            {baseList?.map((item, index) => (
                                <option key={index} value={item._id}>{item.base_number}</option>
                            ))}
                        </select>
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="checker">Ստուգող</label>
                        <input type="text" id="checker" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={checker} onChange={e => setChecker(e.target.value)} />
                    </div>
                    <div className="relative">
                        <label htmlFor="date" className='absolute z-10 top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap'>Ամսաթիվ</label>
                        <DatePicker
                            selected={date ? unGetDate(date) : null}
                            onChange={(date) => setDate(getDate(date))}
                            locale="hy"
                            dateFormat="dd MMMM yyyy"
                            id="date"
                            className="border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200"
                        />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="time">Ժամ</label>
                        <input type="time" id="time" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={time} onChange={e => setTime(e.target.value)} />
                    </div>
                </div>
                <div className='relative mb-2 mt-4'>
                    <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="defects">Ծանոթություն</label>
                    <textarea id="defects" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={acquaintance} onChange={e => setAcquaintance(e.target.value)}/>
                </div>
                
                {/* <div className='grid grid-cols-2 gap-4'>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-gradient-to-t from-gray-200 to-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="rang">Զինկոչում</label>
                        <input type="text" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={rang + " " + (type&& type === "haveTo" ? "" : "Պ")} />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="birthday">Ծննդյան տարեթիվ</label>
                        <input type="date" id="birthday" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={birthday}/>
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="position">Պաշտոն</label>
                        <input className='w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="position" type="text" value={position} disabled />
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="battalion">Գումարտակ</label>
                        <input className='w-full border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="battalion" type="text" value={battalion + " " + company + " " + platoon} disabled />
                    </div>
                    <div className='relative '>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="conscription">Զորակոչ</label>
                        <input type="text" id="conscription" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={conscription} disabled/>
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="milCommissariat">Զինկոմիսարիատ</label>
                        <input type="text" id="milCommissariat" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={milCommissariat} disabled />
                    </div>
                    <div className='relative'>
                        <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="address">Հասցե</label>
                        <input type="text" id="address" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={address} disabled />
                    </div>
                </div> */}
                <div className='grid grid-cols-2 gap-4 justify-center items-center '>
                    <button className='mt-4 bg-blue-500 text-white px-4 py-2 rounded-md' onClick={item ? edit : add}>Պահպանել</button>
                    <button className='mt-4 bg-gray-300 text-white px-4 py-2 rounded-md ' onClick={closeModal}>Փակել</button>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
